<template>
    <div>
        <div class="banner">
            <div class="headerReplacementNewInfo"></div>
            <div class="banner-text">
                <b>{{ $t('newsMedia.title') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('newsMedia.home') }}</router-link></span>
                    <span class="separator"></span>
                    <span>{{ $t('newsMedia.newsRoom') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('newsMedia.title') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <NewInfoTabMenu />
            </div>

            <div class="row g-3 justify-content-center align-items-center mt-3 mb-5">
                <div class="col-md-auto">
                    <label class="col-form-label">{{ $t('newsMedia.search') }}</label>
                </div>
                <div class="col-md-6 position-relative">
                    <input type="text" class="form-control pe-5" v-model="searchQuery"
                        :placeholder="$t('newsMedia.search')" />
                    <i class="fas fa-search position-absolute top-50 end-0 translate-middle-y me-3"></i>
                </div>
                <div class="col-md-auto">
                    <label class="col-form-label">{{ $t('newsMedia.selectYear') }}</label>
                </div>
                <div class="col-md-2">
                    <select v-model="selectedYear" id="yearSelect" class="form-select" aria-label="Year selection">
                        <option v-for="year in uniqueYears" :key="year" :value="year">{{ year }}</option>
                    </select>
                </div>
            </div>

            <!-- News List -->
            <div class="container mb-5">
                <div v-for="(item, index) in filteredNews" :key="index" class="row border-bottom g-2 mb-3">
                    <div class="col-6 text-start">
                        <div class="fw-bold mb-3">{{ item.title_news_medias }}</div>
                    </div>
                    <div class="col-6 text-end">
                        <a :href="item.url_news_medias" target="_blank">
                            <small>{{ $t('newsMedia.readMore') }}</small>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  

<script>
import NewInfoTabMenu from '@/components/NewInfoTabMenu.vue';
import store from "@/store";
import { GET_NEWS_MEDIAS } from "../../store/actions.type";
import dayjs from 'dayjs';

export default {
    name: 'NewsMedia',
    components: {
        NewInfoTabMenu,
    },
    data() {
        return {
            list: [],  // กำหนดค่า default ให้เป็น array ว่าง
            isLoading: false,
            searchQuery: '',        // เพิ่มการเก็บข้อมูลการค้นหา
            selectedYear: '2019',       // ปีเริ่มต้นให้เป็นค่าว่าง (ทั้งหมด)
        };
    },
    computed: {
        // Get unique years from the publish_date_news_medias
        uniqueYears() {
            const years = this.list.map(item => dayjs(item.publish_date_news_medias).year());
            return [...new Set(years)].sort((a, b) => b - a); // Sort in descending order
        },
        // Filtered and Sorted News List
        filteredNews() {
            return this.list
                .filter(item => {
                    const year = dayjs(item.publish_date_news_medias).year();
                    const matchesYear = !this.selectedYear || year === parseInt(this.selectedYear);
                    const matchesSearch = item.title_news_medias.toLowerCase().includes(this.searchQuery.toLowerCase());

                    return matchesYear && matchesSearch;
                })
        }
    },
    watch: {
        '$i18n.locale'(newLang) {
            this.init();
        }
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    methods: {
        async init() {
            // Fetch news data
            try {
                const lang = this.$i18n.locale || 'th';
                const news = await store.dispatch(GET_NEWS_MEDIAS, lang);
                this.list = news; // Save the fetched news
            } catch (error) {
                console.error("Error fetching news data:", error);
            }
        },
        formatDate(dateString) {
            return dayjs(dateString).format('DD MMMM YYYY'); // Format the date
        },
    }
};
</script>

<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
